
<template>
  <vs-popup class="holamundo" popup-class="w-9/12" :title="title" :active.sync="popupActive">
    <form id="formStepStart" data-vv-scope="step-start">
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>نوع پرداخت:</span>
        </div>
        <div class="vx-col sm:w-7/12 flex-inline">
          <v-select
            class="selectExample w-full"
            v-model="selectedPaymentType"
            :options="PaymentTypeList"
          ></v-select>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>نوع کارمزد:</span>
        </div>
        <div class="vx-col sm:w-7/12">
          <ul style="display:flex">
            <li class="mr-4" v-for="item in Object.entries(CommissionType)">
              <vs-radio
                name="commissionType"
                v-model="commission.commissionType"
                :vs-value="item[0]"
              >{{item[1].title}}</vs-radio>
            </li>
          </ul>
        </div>
      </div>
      <div class="vx-row mb-4">
        <div class="vx-col sm:w-3/12 flex-inline">
          <span>کسر از:</span>
        </div>
        <div class="vx-col">
          <ul style="display:flex">
            <li class="mr-4">
              <vs-radio name="userType" v-model="selectedUserType" vs-value="m">پذیرنده</vs-radio>
            </li>
            <li class="mr-4">
              <vs-radio name="userType" v-model="selectedUserType" vs-value="c">مشتری</vs-radio>
            </li>
          </ul>
        </div>
      </div>

      <vx-card class="mb-2">
        <div
          class="vx-row mb-2"
          v-if="commission.commissionType && ['Percent','Fixed'].includes(CommissionType[commission.commissionType].value)"
        >
          <div class="vx-col sm:w-8/12 flex-inline">
            <vs-input
              label="مقدار"
              inputmode="numeric"
              v-model="commissionFee.val"
              class="w-full"
              icon-pack="feather"
              :icon="this.CommissionType[this.commission.commissionType].value=='Percent'?'icon-percent':''"
            />
          </div>
        </div>
        <div
          class="vx-row mb-2"
          v-if="commission.commissionType && ['Percent','Tiered'].includes(CommissionType[commission.commissionType].value)"
        >
          <div class="vx-col sm:w-8/12 flex-inline">
            <vs-input v-model="commissionFee.ceilVal" label="سقف" inputmode="numeric" class="w-full" />
          </div>
        </div>
        <div
          v-if="commission.commissionType && 'Tiered'==CommissionType[commission.commissionType].value"
        >
          <div class="vx-row mb-2" v-for="(item, index) in commissionFee.items" :key="index">
            <div class="vx-col sm:w-3/12 flex-inline">
              <vs-input disabled v-model="item.min" label="از" class="w-full" />
            </div>
            <div class="vx-col sm:w-3/12 flex-inline">
              <vs-input
                v-if="commissionFee.items.length-1>index"
                inputmode="numeric"
                @change="updateMax(item.max,index)"
                v-model="item.max"
                label="تا"
                class="w-full"
              />
              <vs-input
                value="∞"
                disabled
                label="تا"
                v-if="commissionFee.items.length-1==index"
                class="w-full"
              />
              <span
                class="text-danger text-sm"
                v-if="commissionFee.items.length-1>index&&!isNaN(parseInt(item.max))&&item.max<item.min"
              >تداخل بازه ها</span>
            </div>
            <div class="vx-col sm:w-3/12 flex-inline">
              <vs-input
                inputmode="numeric"
                icon-pack="feather"
                :icon="item.isPercent?'icon-percent':''"
                v-model="item.val"
                :key="index"
                label="مقدار"
                class="w-full"
              />
            </div>
            <div class="vx-col flex-inline pt-8">
              <vs-switch color="success" v-model="item.isPercent">
                <span slot="on">%</span>
                <span slot="off">%</span>
              </vs-switch>
            </div>
            <div class="vx-col flex-inline pt-8">
              <feather-icon
                @click="removeItem(index)"
                strokeWidth="2"
                title="حذف"
                icon="XCircleIcon"
                svgClasses="h-6 w-6 text-dark"
              ></feather-icon>
            </div>
          </div>
          <div class="vx-row mb-2">
            <div class="vx-col w-full flex-inline pt-8" style="text-align:center;cursor:pointer">
              <vs-button
                @click="addItem"
                type="flat"
                icon-pack="feather"
                icon="icon-plus"
                color="dark"
                style="margin: 0 auto;"
              >افزودن</vs-button>
            </div>
          </div>
        </div>
      </vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <vs-button class="mr-3 mb-2" @click.prevent="submitForm">ذخیره</vs-button>
          <vs-button color="warning" type="border" class="mb-2" @click="commissionGroup={}">پاک کردن</vs-button>
        </div>
      </div>
    </form>
  </vs-popup>
</template>
<style>
</style>
<script>
import { CreateEditMode, CommissionType, PaymentType } from "@/enums.js";
import vSelect from "vue-select";

export default {
  name: "create-or-edit-commission",
  props: {},
  components: {
    "v-select": vSelect
  },
  data() {
    return {
      CommissionType,
      PaymentType,
      popupActive: false,
      createEditMode: CreateEditMode.Create,
      commission: {
        commissionType: 2
      },
      selectedUserType: "m",
      selectedPaymentType: null,
      commissionFee: {
        val: 0,
        ceilVal: 0,
        items: [{ min: 0, max: 0, val: 0, isPercent: true }]
      },
      title: ""
    };
  },
  computed: {
    PaymentTypeList: function() {
      let ms = [];
      for (let [key, value] of Object.entries(this.PaymentType)) {
        ms.push({ value: key, label: value.title });
      }
      return ms;
    }
  },
  methods: {
    validate() {
      if (!this.selectedPaymentType) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "نوع پرداخت انتخاب شود"
        });
        return false;
      }
      if (!this.commission.commissionType) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "نوع کارمزد انتخاب شود"
        });
        return false;
      }
      if (!this.selectedUserType) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "نوع کاربر انتخاب شود"
        });
        return false;
      }
      if (
        ["Percent", "Fixed"].includes(
          this.CommissionType[this.commission.commissionType].value
        ) &&
        isNaN(parseInt(this.commissionFee.val))
      ) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "مقدار وارد شود"
        });
        return false;
      }
      if (
        ["Percent", "Tiered"].includes(
          this.CommissionType[this.commission.commissionType].value
        ) &&
        isNaN(parseInt(this.commissionFee.ceilVal))
      ) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "خطا!",
          text: "سقف وارد شود"
        });
        return false;
      }
      if (
        "Tiered" == this.CommissionType[this.commission.commissionType].value
      ) {
        if (!this.commissionFee || !this.commissionFee.items) {
          this.$vs.notify({
            time: 5000,
            color: "danger",
            title: "خطا!",
            text: "هیچ بازه‌ای تعریف نشده است"
          });
          return false;
        }
        for (let i = 0; i < this.commissionFee.items.length - 1; i++) {
          const x = this.commissionFee.items[i];
          if (
            isNaN(parseInt(x.min)) ||
            isNaN(parseInt(x.max)) ||
            x.min > x.max
          ) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "خطا!",
              text: "بازه‌ها بصورت صحیح انتخاب شود"
            });
            return false;
          }
        }

        for (let i = 0; i < this.commissionFee.items.length; i++) {
          const x = this.commissionFee.items[i];
          if (isNaN(parseInt(x.val))) {
            this.$vs.notify({
              time: 5000,
              color: "danger",
              title: "خطا!",
              text: "مقدار بازه‌ها بصورت صحیح وارد شود"
            });
            return false;
          }
        }
        
      }
      return true;
    },
    buildCommissionFee() {
      let commissionFee = JSON.parse(JSON.stringify(this.commissionFee));
      switch (this.CommissionType[this.commission.commissionType].value) {
        case "Fixed":
          delete commissionFee.items;
          delete commissionFee.ceilVal;
          break;
        case "Percent":
          delete commissionFee.items;
          break;
        case "Tiered":
          delete commissionFee.val;
          break;
      }
      return JSON.stringify(commissionFee);
    },
    submitForm() {
      if (!this.validate()) return;
      this.commission.paymentType = this.selectedPaymentType.value;
      this.commission.commissionGroupId =this.$route.params.commissionGroupId;
      this.commission.commissionFee = this.buildCommissionFee();
      this.commission.userType = this.selectedUserType == "m" ? 1 : 0;

      let loading = this.$vs.loading();
      this.$http
        .post("/api/services/app/Commissions/CreateOrEdit", this.commission)
        .then(response => {
          if (response.data.success == true) {
            this.popupActive = false;
            this.$vs.notify({
              time: 5000,
              color: "success",
              title: "موفق!",
              text: "‌کارمزد با موفقیت ذخیره شد"
            });
            this.$emit("success");
          }
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    show(id, name) {
      this.commissionGroup = {};
      if (id) {
        this.createEditMode = CreateEditMode.Edit;
        this.title = 'ویرایش ‌کارمزد "' + name + '"';
        this.get(id);
      } else {
        this.createEditMode = CreateEditMode.Create;
        this.title = "کارمزد جدید";
        // this.commissionGroup.name='';
        // this.commissionGroup.description='';
      }
      this.popupActive = true;
    },
    async get(id) {
      let loading = this.$vs.loading();
      //this.$vs.loading()

      let payload = {
        params: {
          id: id
        }
      };
      this.$http
        .get("/api/services/app/Commissions/GetCommissionForEdit", payload)
        .then(async response => {
          this.commission = response.data.result.commission;
          this.selectedUserType = this.commission.userType == 1 ? "m" : "c";
          this.selectedPaymentType = this.PaymentTypeList.find(
            x => x.value == this.commission.paymentType
          );
          this.commissionFee = JSON.parse(this.commission.commissionFee);
          this.$vs.loading.close();
        }) //end success
        .catch(error => {
          this.$vs.loading.close();
        }); //end http
    },
    addItem() {
      if (!this.commissionFee || !this.commissionFee.items) {
       
        this.$set(this.commissionFee, "items", [
          { min: 0, max: 0, val: 0, isPercent: true }
        ]);
        return;
      }

      let preMax = this.commissionFee.items[this.commissionFee.items.length - 1]
        .max;
      this.commissionFee.items.push({
        min: isNaN(parseInt(preMax)) ? "" : parseInt(preMax) + 1,
        max: null,
        val: null,
        isPercent: true
      });
    },
    removeItem(i) {
      if (this.commissionFee.items.length < 2) {
        this.$vs.notify({
          time: 5000,
          color: "danger",
          title: "اخطار!",
          text: "تمام بازه ها را نمیتوانید حذف کنید"
        });
        return;
      }
      this.commissionFee.items.splice(i, 1);
    },
    updateMax(value, index) {
      if (this.commissionFee.items.length > index + 1)
        this.commissionFee.items[index + 1].min = isNaN(parseInt(value))
          ? ""
          : parseInt(value) + 1;
    }
  },
  mounted() {
    this.selectedPaymentType = this.PaymentTypeList.find(x => x.value == 2);
  }
};
</script>